export { default as FlagIconUz } from '../assets/uzFlag.svg';
